// removed by extract-text-webpack-plugin
module.exports = {"container":"displayActorEmails-module-container-1f74f5212ae577cf2f1a93fb6d8cfac5--","actor":"displayActorEmails-module-actor-ef8c6ccd2044b75470b5e342a2153229--","actorcard":"displayActorEmails-module-actorcard-9cd11565805c1802f21274b1a8202d4e--"};


//////////////////
// WEBPACK FOOTER
// /src/components/mailThread/mail/displayActorEmails/displayActorEmails.module.scss
// module id = 1932
// module chunks = 0